import React from 'react';
import classnames from 'classnames';
import { useSelector } from 'react-redux';

// Selectors
import * as meetingItemSelectors from 'Shared/selectors/MeetingItems.selectors';

// Helpers
import MeetingItemHelpers from 'Shared/model_helpers/MeetingItem.helper';

// Components
import MeetingItemInput from 'Shared/components/MeetingItemInput/MeetingItemInput';

// Styles
import './AgendaListItem.scss';

type Props = {
  meetingItemUuid: string;
};
const AgendaListItem = ({ meetingItemUuid }: Props) => {
  const meetingItem = useSelector(state => meetingItemSelectors.getMeetingItemByUuid(state, { meetingItemUuid })).get(
    meetingItemUuid
  );

  const parentUuid = MeetingItemHelpers.getParentUuid(meetingItem);
  const hasParent = Boolean(parentUuid);

  const isSection = MeetingItemHelpers.getIsSection(meetingItem);
  const isCompleted = MeetingItemHelpers.getCompleted(meetingItem);

  const baseClassName = 'AgendaListItem';
  const classes = classnames(
    baseClassName,
    hasParent && `${baseClassName}--sub-item`,
    isCompleted && `${baseClassName}--completed`
  );

  return (
    <div className={classes}>
      <MeetingItemInput meetingItem={meetingItem} readonly hideDescription={isSection} />
    </div>
  );
};

export default AgendaListItem;
